import {CheckOutlined, ClockCircleOutlined, CloseOutlined} from '@ant-design/icons';
import {TagProps} from 'antd/es/tag';
import {AccountFieldsFragment, AccountStatus} from 'api/generated';
import {StatusTag} from 'components/StatusTag';
import {colors} from 'lib/colors';
import {accountStatusLabels} from 'lib/labels';
import React from 'react';

interface Props extends TagProps {
  account: AccountFieldsFragment;
}

export const AccountStatusTag: React.FC<Props> = ({account, ...props}) => {
  const getStatusTag = () => {
    const statusLabel = accountStatusLabels[account.status];
    switch (account.status) {
      case AccountStatus.NOT_CONFIGURED:
        return (
          <StatusTag {...props} color={colors.grey}>
            {statusLabel} <ClockCircleOutlined />
          </StatusTag>
        );
      case AccountStatus.PENDING_CONTRACT:
        return (
          <StatusTag {...props} color={colors.grey}>
            {statusLabel} <ClockCircleOutlined />
          </StatusTag>
        );
      case AccountStatus.PENDING_APPROVAL:
      case AccountStatus.PENDING_REVIEW:
        return (
          <StatusTag {...props} color={colors.grey}>
            {statusLabel} <ClockCircleOutlined />
          </StatusTag>
        );

      case AccountStatus.REJECTED:
        return (
          <StatusTag {...props} color={colors.error}>
            {statusLabel} <CloseOutlined />
          </StatusTag>
        );
      case AccountStatus.ACTIVE:
        return (
          <StatusTag {...props} color={colors.success}>
            {statusLabel} <CheckOutlined />
          </StatusTag>
        );
      case AccountStatus.APPROVED:
        return (
          <StatusTag {...props} color={colors.success}>
            {statusLabel} <CheckOutlined />
          </StatusTag>
        );
      case AccountStatus.SUSPENDED:
        return (
          <StatusTag {...props} color={colors.error}>
            {statusLabel} <CloseOutlined />
          </StatusTag>
        );
      case AccountStatus.DELETED:
        return (
          <StatusTag {...props} color={colors.error}>
            {statusLabel} <CloseOutlined />
          </StatusTag>
        );
      default:
        return (
          <StatusTag {...props} color={colors.grey}>
            {account.status}
          </StatusTag>
        );
    }
  };

  return getStatusTag();
};
